export default (state: any) => {
  const resourcesResponse = () => {
    return state.resources
  }

  const resources = () => {
    return state.resources.items
  }

  const resource = () => {
    return state.resource
  }

  return {
    resourcesResponse,
    resources,
    resource,
  }
}
